import { useTranslateProductNames } from 'hooks/use-translate-payoff';
import { uniq } from 'lodash-es';
import { FormattedMessage } from 'react-intl';
import { SupportProductList } from 'routes/smart-quote/components/disclaimer/supported-product-list';
import { AstroProductKey } from 'state/workspaces/smart-quote/model';
export function UnsupportedProductPrompt({ products }: { products: AstroProductKey[] }) {
  const translations = useTranslateProductNames(
    products.map(p => ({ productType: p.instrument.name, productSubType: p.instrument.contractName })),
  );
  const productSubtypeLabels = uniq(translations.map(t => t.productSubtypeLabel)).join(', ');
  return (
    <div className="flex-y py-3 pb-2 gap-4">
      <p>
        <FormattedMessage id="smartQuote.unsupportedProduct.summary" values={{ productName: productSubtypeLabels }} />
      </p>
      <h5>
        <FormattedMessage id="smartQuote.unsupportedProduct.listTitle" />
      </h5>
      <SupportProductList />
    </div>
  );
}
